import React from "react";
import {observer} from "mobx-react-lite";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {ResidentPresentation} from "./residentPresentation";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const ResidentPresentationPage = observer(() => {
  const nursingHomeId = nursingHomeStore.getId();
  return <ConsentDocumentsLayout>{nursingHomeId
    ? <ResidentPresentation nursingHomeId={nursingHomeId}/>
    : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home to present this form."/>
  }</ConsentDocumentsLayout>;
});
